(async function () {
  function waitForTryNow(maxRetries = 50, interval = 100) {
    return new Promise((resolve, reject) => {
      let retries = 0;

      const check = () => {
        if (window.trynow) {
          resolve(window.trynow);
        } else {
          retries++;
          if (retries >= maxRetries) {
            reject(new Error("window.trynow did not load in time"));
          } else {
            setTimeout(check, interval);
          }
        }
      };

      check();
    });
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  try {
    await waitForTryNow();

    const rawSearch = window.location.search;
    const params = new URLSearchParams(rawSearch);

    const isMetaShopper =
      getCookie("_tnfb") === "true" || // Rely on SDK cookie
      (await window.trynow.blockFacebookReferredTraffic());


    if (isMetaShopper) {
      const style = document.createElement("style");
      style.innerHTML = `
        .trynow-subhero-banner,
        [link-title="Try Before You Buy"],
        [link-title="Try At Home"],
        .tryNowCtaBanner.tryNowCtaBannerDesktop,
        .tryNowCtaBanner.tryNowCtaBannerMobile,
        .trynowBadgeLabel,
        .trynowBadgeLabel.trynowBadgeLabelMobile,
        .tnDescription,
        .trynowBadgeLabelToggle,
        .tryNowPriceToggle,
        .try-banner,
        .tryNow_quick_link,
        .trynow-grid-item,
        #HeaderMenu-try-it-free,
        div:has(>img[alt="Try Free"]),
        #_loomi_addon_1754388218096,
        .tryNowSwitch {
          display: none !important;
        }

        ProductMeta__PriceList.Heading.Price_List_Mobile.observer .ProductMeta__Price.ProductDynamic_Money {
          display: block !important;
        }

        .Heading.Price_List_Mobile.observer .ProductMeta__Price.Price.Price--compareAt {
          display: unset !important;
        }

        .Heading.Price_List_Mobile.observer .ProductMeta__Price.Price.Price--highlight {
          display: unset !important;
        }

        .ProductMeta__PriceList.Heading.Price_List_Desktop.observer .ProductMeta__Price.ProductDynamic_Money {
          display: block !important;
        }

        .tbyb-atc-meta-blocked {
          display: unset !important;
        }
      `;
      document.head.appendChild(style);
    }
  } catch (error) {
    console.warn("❌ Failed waiting for TryNow:", error);
  }
})();